import React, { useState } from "react";

import {
  Col,
  Row,
  Form,
  Button,
  Container,
  Image,
} from "@themesberg/react-bootstrap";

import axios from "axios";
import ButtonLoader from "../../components/ButtonLoader";
import { dropdownItems } from "../../data/tables";
import swal from "sweetalert";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { registerVendor } from "../../app/api";
import logo from "../../assets/img/vendor.png";

export default () => {
  const [vendorName, setVendorName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [position, setPosition] = useState("");
  const [worklocation, setWorkLocation] = useState("");

  const [loadingBtn, setLoadingBtn] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    try {
      const vendoData = {
        contact_person: vendorName,
        phone: phoneNumber,
        company_name: company,
        email,
        address,
        position,
        location: worklocation,
      };
      let response;

      response = await axios.post(registerVendor(), vendoData, {
        headers: {
          "Content-Type": "application/json", // Set Content-Type to application/json
          "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
        },
      });
      swal({
        title: "Submitted!",
        text: "Thank you for submitting the information. After the admin approves you'll get an email!",
        icon: "success",
      });

      // console.log(response.data);
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
    }
  };
  return (
    <main>
      <section className="d-flex align-items-center my-5 ">
        <Container>
    

          <Row className="justify-content-center form-bg-image">
 
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-1000">
                <div className=" d-flex flex-column align-items-center text-center text-md-center mb-4 mt-md-0">
                  <Image src={logo} className="logo_img  mb-4 " />

                  <h3 className="mb-0">Vendor Registration Form</h3>
                </div>

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group id="vendorname">
                        <Form.Label>Vendor Name</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Enter Vendor name"
                          value={vendorName}
                          onChange={(e) => setVendorName(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group id="company">
                        <Form.Label>Company</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Enter Company name"
                          value={company}
                          onChange={(e) => setCompany(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group id="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group id="phone">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Enter Phone Number"
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group id="options">
                        <Form.Label>Options</Form.Label>
                        <Form.Select
                          value={position}
                          onChange={(e) => setPosition(e.target.value)}
                        >
                          <option value="">Select an option</option>
                          {dropdownItems.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group id="location">
                        <Form.Label>Work Location</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Enter Work Location"
                          value={worklocation}
                          onChange={(e) => setWorkLocation(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Col md={12} className="mb-3">
                    <Form.Group id="address">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  {loadingBtn ? (
                    <div className="d-flex justify-content-end">
                      <ButtonLoader />
                    </div>
                  ) : (
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="primary"
                        type="submit"
                        className="w-auto mt-2 "
                      >
                        Register
                      </Button>
                    </div>
                  )}
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
